import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SvcDialogService } from '@solvace/component/svc-dialogs';
import { SvcPrinterData } from './svc-printer-classes';
import { SvcPrinterModalComponent } from './svc-printer-modal.component';

@Injectable({
  providedIn: 'root',
})
export class SvcPrinterService {
  #svcDialogService = inject(SvcDialogService);

  public closePrinter$ = new Subject<void>();

  public open(data: SvcPrinterData): void {
    this.#svcDialogService
      .open(SvcPrinterModalComponent, {
        data: data,
        width: '100%',
        maxWidth: '400px',
      })
      .afterClosed()
      .subscribe(() => {
        this.closePrinter$.next();
      });
  }
}
